<template>
  <div>
    <FilterManagerParent
        @exportExcel="handleExportExcel"
    >
      <TableDataManagerParent
        ref="dataParent"
      />
    </FilterManagerParent>
  </div>
</template>

<script>

import FilterManagerParent from "@/parent/manager/component/FilterManagerParent.vue";
import TableDataManagerParent from "@/parent/manager/component/TableDataManagerParent.vue";
export default {
  components: {
    FilterManagerParent,
    TableDataManagerParent,
  },

  methods: {
    handleExportExcel(value) {

      switch (value) {
        case 'all':
          this.$refs.dataParent.exportExcelDataParent();
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>